import Navbar from '../components/cummon/Navbar';

import Footer from '../components/cummon/Footer';

import ResourcesHero from '../components/resources/resourcesHero';

import ResourceLibrary from '../components/resources/ResourcesLibrary';

import CustomCTA from '../components/resources/Rcta';



function ResourcesPage() {
  return (
    <div className="min-h-screen  bg-white">
      <Navbar />
       
        <ResourcesHero />
        <ResourceLibrary />
        <CustomCTA />
      
      <Footer />
      
    
    
    </div>
  );
}

export default ResourcesPage;